import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Brain, Check } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

const tiers = [
  {
    name: "Free",
    price: "$0",
    cadence: "forever",
    cta: "Current plan",
    features: ["Up to 30 players per room", "All game modes", "Anonymous rooms", "Real-time sync"],
    highlight: false,
  },
  {
    name: "Pro",
    price: "$19",
    cadence: "/ month",
    cta: "Coming soon",
    features: [
      "Up to 200 players per room",
      "Session history & exports",
      "AI-generated trivia (coming)",
      "Jira / Linear sync (coming)",
      "Priority support",
    ],
    highlight: true,
  },
  {
    name: "Team",
    price: "$5",
    cadence: "/ user / month",
    cta: "Contact us",
    features: [
      "Everything in Pro",
      "Up to 500 players per room",
      "Custom branding & logo",
      "SSO (SAML)",
      "Admin & billing console",
    ],
    highlight: false,
  },
];

const Pricing = () => {
  return (
    <main className="min-h-screen px-4 py-10 relative">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="max-w-5xl mx-auto space-y-10">
        <header className="text-center space-y-3">
          <Link to="/" className="inline-flex items-center gap-2">
            <div className="h-10 w-10 rounded-2xl gradient-fun flex items-center justify-center shadow-pop">
              <Brain className="h-5 w-5 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-extrabold text-xl">SameBrain</span>
          </Link>
          <h1 className="text-4xl font-extrabold tracking-tight">Pricing</h1>
          <p className="text-muted-foreground">Free for small teams. Pay when you grow.</p>
        </header>

        <div className="grid md:grid-cols-3 gap-4">
          {tiers.map((t) => (
            <Card
              key={t.name}
              className={`p-6 border-2 space-y-5 ${t.highlight ? "border-primary shadow-pop" : "shadow-card"}`}
            >
              <div className="space-y-1">
                <div className="text-xs uppercase tracking-wider text-muted-foreground">{t.name}</div>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-extrabold">{t.price}</span>
                  <span className="text-muted-foreground text-sm">{t.cadence}</span>
                </div>
              </div>
              <ul className="space-y-2 text-sm">
                {t.features.map((f) => (
                  <li key={f} className="flex gap-2">
                    <Check className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Button
                disabled
                className={`w-full h-11 font-bold ${t.highlight ? "gradient-primary" : ""}`}
                variant={t.highlight ? "default" : "outline"}
              >
                {t.cta}
              </Button>
            </Card>
          ))}
        </div>

        <p className="text-center text-xs text-muted-foreground">
          Payments launching soon. <Link to="/account" className="underline">Back to account</Link>
        </p>
      </div>
    </main>
  );
};

export default Pricing;
